<template>
  <div v-resize="onResize" class="px-4">
    <a-data-table
      v-model="selectedFiles"
      :headers="showHeaders"
      :items="documentItems"
      :search="search"
      dense
      fixed-header
      :height="screenHeight"
      :items-per-page="-1"
      hide-default-footer
      mobile-breakpoint="0"
      :no-data-text="$t('noData')"
      :no-results-text="$t('emptySearchRecords')"
      show-select
      item-key="documentId"
      :sort-by="sortOnColumn"
      :sort-desc="sortType"
      :must-sort="true"
    >
      <template v-slot:[`item.fileName`]="{ item }">
        <v-icon class="mr-2" v-if="!item.extension"> mdi-file </v-icon>
        <v-icon class="mr-2" v-else>
          {{ fileIcons[item.extension] || "mdi-file" }}
        </v-icon>
        <a
          class="title overflow-wrap"
          v-if="
            $security.checkMeetingTypeAccess(
              item.meetingTypeId,
              'OpenMeetingDocument'
            )
          "
          @click="onFileDownload(item)"
          >{{ item.fileName }}</a
        >
        <span v-else>{{ item.fileName }}</span>
      </template>

      <template v-slot:[`item.meetingName`]="{ item }">
        {{ item.meetingName }}
      </template>

      <template v-slot:[`item.scheduletStartTimeInUTC`]="{ item }">
        <span v-if="item.scheduletStartTime">{{ getDay(item.scheduletStartTime) }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:[`item.topicText`]="{ item }">
        <p class="subtitle-2 pa-0 ma-0 overflow-wrap">
          {{ item.topicText }}
        </p>
      </template>

      <template v-slot:[`item.datetime`]="{ item }">
        <p class="subtitle-2 pa-0 ma-0">
          {{ getDate(item.datetime) }}
        </p>
      </template>
    </a-data-table>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { isoIntlDateFormat, openDocument } from "../../utils/util";
import _ from "lodash";

export default {
  name: "AgendaDocumentsListView",
  components: {},
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    search: String,
    value: {
      type: Array,
      default: () => [],
    },
    defaultSortOrder: {
      type: Object,
      default: () => ({ sortOnColumn: "datetime", sortType: "desc" }),
    },
  },
  data() {
    return {
      screenHeight: 0,
      fileIcons: {
        zip: "mdi-folder-zip-outline",
        rar: "mdi-folder-zip-outline",
        htm: "mdi-language-html5",
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-json",
        md: "mdi-markdown",
        pdf: "mdi-file-pdf-box",
        png: "mdi-file-image",
        jpg: "mdi-file-image",
        jpeg: "mdi-file-image",
        mp4: "mdi-filmstrip",
        mkv: "mdi-filmstrip",
        avi: "mdi-filmstrip",
        wmv: "mdi-filmstrip",
        mov: "mdi-filmstrip",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
        other: "mdi-file-outline",
      },
    };
  },
  computed: {
    selectedLang() {
      return this.$i18n.locale;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    selectedFiles: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },
    documentItems() {
      const documentList = [];
      this.files.forEach((document) => {
        documentList.push({
          topicText: document.topicName || "-",
          fileName: document.fileName,
          meetingName: document.meetingName || "-",
          scheduletStartTime: document.scheduletStartTimeInUTC || "",
          scheduletStartTimeInUTC: document.scheduletStartTimeInUTC ? new Date(document.scheduletStartTimeInUTC).getTime() : 0,
          size: "100kb",
          lastModified: document.lastModified || "2022-01-04 09:10",
          extension: document.fileName.split(".").pop(),
          documentId: document.id,
          datetime: document.uploaded_at || document._ts,
          meetingTypeId: document.meetingTypeId,
        });
      });
      return documentList;
    },
    showHeaders() {
      return this.headers.filter((s) => s.visible === true);
    },
    headers() {
      return [
        {
          text: this.$t("lblSearchTextDocumentFolder"),
          align: "left",
          value: "fileName",
          visible: true,
          width: "23%",
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblMeetingTitle"),
          align: "left",
          value: "meetingName",
          visible: true,
          width: "20%",
          class: "header header-text",
        },
        {
          text: this.$t("agenda.lblMeetingDate"),
          align: "left",
          value: "scheduletStartTimeInUTC",
          visible: true,
          width: "20%",
          class: "header header-text",
        },
        {
          text: this.$t("documents.topic"),
          align: "left",
          value: "topicText",
          visible: true,
          class: "header header-text",
        },
        {
          text: this.$t("documents.lblUploadTime"),
          align: "left",
          value: "datetime",
          visible: true,
          width: "18%",
          class: "header header-text",
        },
        // {
        //   text: this.$t("documents.modified"),
        //   align: "left",
        //   value: "lastModified",
        //   visible: false,
        // },
        // {
        //   text: this.$t("documents.size"),
        //   align: "left",
        //   value: "size",
        //   visible: false,
        // },
      ];
    },
    sortOnColumn() {
      if (this.defaultSortOrder) {
        return this.defaultSortOrder.sortOnColumn;
      }
      return "datetime";
    },
    sortType() {
      if (this.defaultSortOrder) {
        return this.defaultSortOrder.sortType === "desc";
      }
      return true;
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
    }),
    customSorting(items, sortBy, sortDesc) {
      if (sortBy[0] === "datetime" && Boolean(sortDesc)) {
        return _.orderBy(items, [sortBy[0]], [sortDesc[0] ? "desc" : "asc"]);
      }
      if (
        sortBy[0] === "fileName" ||
        sortBy[0] === "topicText" ||
        sortBy[0] === "meetingName"
      ) {
        return _.orderBy(
          items,
          [
            (item) => {
              const tokens = item[sortBy[0]].split(/(\d+)/).filter(Boolean);
              return tokens.map((token) => {
                if (!isNaN(token)) {
                  return parseInt(token, 10);
                }
                return token.toLowerCase();
              });
            },
          ],
          [sortDesc[0] ? "desc" : "asc", "asc"]
        );
      }
      return items;
    },
    getDate(date) {
      return isoIntlDateFormat(this.$i18n.locale, date);
    },
    onResize() {
      this.screenHeight = window.innerHeight - 275;
    },
    async onFileDownload(file) {
      const params = {
        documentId: file.documentId,
        filename: file.fileName,
      };
      const res = await this.downloadDocumentAPI(params);
      let contentType = res.headers["content-type"];
      let blob = new Blob([res.data], { type: contentType });
      let url = window.URL.createObjectURL(blob);
      openDocument(url, file.fileName);
    },
    getDay(meetingdate) {
      let Xmas95 = new Date(meetingdate);
      let options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.$i18n.locale, options).format(Xmas95);
    },
  },
};
</script>

<style scoped>
.v-application .title {
  font-size: 16px !important;
  line-height: 24px !important;
  font-family: "Noto Sans JP" !important;
}
.v-application .subtitle-2 {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: var(--v-darkCharcoal-base) !important;
  line-height: 21px !important;
  font-family: "Noto Sans JP" !important;
}

::v-deep tbody tr {
  height: 20px !important;
}
::v-deep thead th {
  padding: 4px 12px !important;
}
::v-deep tbody td {
  height: 20px !important;
  border-bottom: thin solid var(--v-secondary-base) !important;
  padding: 5px 12px !important;
}
::v-deep th {
  background: var(--v-neutralGray-base) !important;
  color: #ffffff !important;
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
}
::v-deep .v-input--selection-controls__ripple {
  border-radius: unset !important;
  height: unset !important;
  width: unset !important;
}

::v-deep .v-simple-checkbox .v-icon {
  cursor: pointer;
}
</style>